(function($) {
    var numSlick = 0;
    var $sliderContainer = $('.slider-fade');

    // Slider with fading slides. (options can be set as data attributes)
    $sliderContainer.each(function() {
        numSlick++;

        $(this).addClass('slider-fade-' + numSlick).slick({
            accessibility: false,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3000,
            dots: false,
            fade: true,
            infinite: true,
            pauseOnFocus: false,
            pauseOnHover: false,
            slide: '.slider-item',
            slidesToScroll: 1,
            slidesToShow: 1,
        })
        .on('setPosition', function (event, slick) {
            $(slick.$slides).height('auto').css('height', $(slick.$slideTrack).height() + 'px');
        });
    });

})(jQuery);
